module.exports = __webpack_public_path__ + "img/mc1-cb2-l2-tf.c668a287.png";